export const events = {
  goToSecuritySettings: 'Go to security settings',
}
